import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiKeyService } from "@/services/api/api-key.service";
import type { CreateApiKeyRequest } from "@/types/api-key.types";

export const apiKeyQueryKeys = {
  all: ["api-keys"] as const,
};

export function useApiKeys(enabled = true) {
  return useQuery({
    queryKey: apiKeyQueryKeys.all,
    queryFn: () => apiKeyService.list(),
    enabled,
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateApiKeyRequest) => apiKeyService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeyQueryKeys.all });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (keyId: string) => apiKeyService.revoke(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeyQueryKeys.all });
    },
  });
}
